<template>
    <div v-if="prices.length">
        <div class="table-responsive max-height-500 mt-5">
            <table class="table table-hover">
                <thead class="bg-c-dark text-white">
                    <tr>
                        <th class="w-50">
                            <small>{{ localise("global", "title") }}</small>
                        </th>
                        <th class="w-25 text-center">
                            <small>{{
                                localise("global", "description")
                            }}</small>
                        </th>
                        <th class="w-25 text-center">
                            <small>{{ localise("global", "price") }}</small>
                        </th>
                        <th class="text-center">
                            <small>{{ localise("global", "action") }}</small>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="price in prices" :key="price.id">
                        <td>
                            <a
                                :data-fancybox="`image${price.id}`"
                                :data-src="`/storage/${price.image}`"
                                v-if="price.image"
                            >
                                <img
                                    height="40"
                                    class="rounded shadow cursor-zoom me-1"
                                    :src="`/storage/${price.image}`"
                                    :alt="price[`title_${$store.state.locale}`]"
                                />
                            </a>
                            <small>{{
                                price[`title_${$store.state.locale}`]
                            }}</small>
                        </td>
                        <td class="text-center">
                            <small>{{ price.size ?? "-" }}</small>
                        </td>
                        <td class="text-center">
                            <small
                                class="badge bg-success shadow rounded-pill"
                                >{{
                                    price.price
                                        ? `${price.price}₾`
                                        : localise("global", "free")
                                }}</small
                            >
                        </td>
                        <td class="text-center">
                            <div v-if="price.multiple_bookings">
                                <button
                                    class="btn btn-sm btn-c-primary shadow rounded-c-3 px-4 py-2 text-white"
                                    data-bs-toggle="modal"
                                    data-bs-target="#bookModal"
                                    @click="book(price)"
                                >
                                    {{ localise("global", "book") }}
                                </button>
                            </div>
                            <div v-else>
                                <button
                                    class="btn btn-sm btn-c-primary shadow rounded-c-3 px-4 py-2 text-white"
                                    data-bs-toggle="modal"
                                    data-bs-target="#bookModal"
                                    @click="book(price)"
                                    v-if="!price.processing && !price.confirmed"
                                >
                                    {{ localise("global", "book") }}
                                </button>
                                <small
                                    v-else-if="price.processing"
                                    class="badge bg-warning shadow rounded-c-3 px-4 py-2 text-c-dark"
                                    >{{
                                        localise("global", "processing")
                                    }}</small
                                >
                                <small
                                    v-else-if="price.confirmed"
                                    class="badge bg-danger shadow rounded-c-3 px-4 py-2"
                                    >{{
                                        localise("global", "confirmed")
                                    }}</small
                                >
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <CommercialBookingModal :price="price" @refresh-pricelist="getPrices" />
</template>

<script>
import translations from "../../helpers/translations";
import { commercialPrices } from "../../services/InternalApiService";
import CommercialBookingModal from "./CommercialBookingModal.vue";

export default {
    name: "CommercialProjects",
    props: ["category_id"],
    components: { CommercialBookingModal },
    data() {
        return {
            prices: [],
            price: {},
        };
    },
    methods: {
        getPrices() {
            commercialPrices({
                category_id: this.category_id,
            })
                .then((res) => {
                    this.prices = res.data.data;
                })
                .catch(console.error());
        },
        book(obj) {
            this.price = obj;
        },
        localise(cat, key) {
            return translations[this.$store.state.locale][cat][key];
        },
    },
    mounted() {
        this.getPrices();
    },
};
</script>

<style scoped>
.cursor-zoom {
    cursor: zoom-in;
}

.max-height-500 {
    max-height: 500px;
}
</style>
